module.exports = __webpack_public_path__ + "img/translate-twelve.b6f8651b.png";